// Matches UserRole definition in backend
export enum UserRole {
  Admin,
  CoreMember,
  Capgemini,
  External,
  Anonymous,
}
